'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (scales, configuration, dimensions) {
    return function (container, data) {
        var separators = container.selectAll('.line-separator').data(data);

        separators.enter().append('g').classed('line-separator', true).attr('transform', function (d, i) {
            return 'translate(0, ' + (scales.y(i) + configuration.lineHeight) + ')';
        }).append('line').attr('x1', 0).attr('x2', dimensions.width - configuration.leftWidth);

        separators.exit().remove();
    };
};
//# sourceMappingURL=lineSeparator.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ansyn-event-drops/dist-es5/drawer/lineSeparator.js
// module id = ../../../../ansyn-event-drops/dist-es5/drawer/lineSeparator.js
// module chunks = vendor